var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.base},[_c('settings-cta',{attrs:{"title":`${_vm.pre}.title`,"description":`${_vm.pre}.description`,"cta":`${_vm.pre}.cta`},on:{"click":function($event){_vm.show = true}}}),(_vm.show)?_c('SsoAttributesMappingSettingsDrawer',{attrs:{"show":_vm.show},on:{"close":function($event){_vm.show = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }